import { t } from "@bezbolisno/i18n";
import { ApiError } from "../../lib/api";

/**
 * Better Auth's client answers `{ data, error }`; the profile mutations want the data or a
 * thrown error so `useMutation` surfaces it — and the thrown error is the app's `ApiError`,
 * so a 401 (the session is gone) takes the same road to /login as any other call.
 */
export interface AuthClientError {
  code?: string;
  message?: string;
  status: number;
}

export function unwrapAuth<T>(res: { data: T | null; error: AuthClientError | null }): T {
  if (res.error) throw new ApiError(res.error.status, res.error.code ?? "unknown", res.error);
  return res.data as T;
}

/** Better Auth error codes (and the API's own hook codes) → the dictionary. */
const BY_CODE: Record<string, string> = {
  NAME_TOO_SHORT: t.profile.errors.nameTooShort,
  LAST_NAME_REQUIRED: t.profile.errors.lastNameRequired,
  NAME_TOO_LONG: t.profile.errors.nameTooLong,
  INVALID_PASSWORD: t.profile.errors.wrongCurrent,
  PASSWORD_TOO_SHORT: t.profile.errors.tooShort,
  PASSWORD_TOO_LONG: t.profile.errors.tooLong,
};

export function authErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 429) return t.auth.tooManyAttempts;
    const known = BY_CODE[error.code];
    if (known) return known;
  }
  return t.profile.errors.generic;
}
